import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getSessionId } from '@fs/zion-session'
import { useEvent } from '@fs/zion-frontend-friends'
import { useStatusOverlay } from '@fs/zion-ui'
import { compareTree, deleteTree, useTrees } from '../../lib/my-trees-service'

export default function useGenealogyTrees() {
  const [t] = useTranslation()

  const sessionId = getSessionId()
  const [beingDeleted, setBeingDeleted] = useState(false)
  const showStatusOverlay = useStatusOverlay()
  const [{ data: trees, error }, refetch] = useTrees(sessionId)

  const handleDelete = useEvent(async (treeUri) => {
    setBeingDeleted(true)

    try {
      await deleteTree(sessionId, treeUri)
      refetch()
    } catch (err) {
      console.error(err)
      showStatusOverlay({
        type: 'error',
        message: t('tree-import.upload-trees.error.delete_error'),
      })
    } finally {
      setBeingDeleted(false)
    }
  })

  const handleCompare = useEvent((treeUri) => {
    compareTree(sessionId, treeUri)
      .then(refetch)
      .catch((err) => {
        console.error(err)
        showStatusOverlay({
          type: 'error',
          message: t('tree-import.upload-trees.error.compare_queue_connection'),
        })
      })
  })

  return { trees, error, beingDeleted, handleCompare, handleDelete, refetch }
}
